import _ from 'lodash';
import { createNewGroup } from './entityRecommender.helper';

/** Retrieves the intial State Object */
const getNewStateObject = () => {
  return {
    loading: false,
    loadingRecommendations: false,
    queryTree: [createNewGroup(false)],
    isExecuteClicked: false,
    newClassifierName: '',
    pageNotification: {show: false, msg: '', type: ''}
  };
}

const getPageNotificationObject = (target, msg, type) => {
  return {
    show: true,
    target: target,
    msg: msg,
    type: type
  };
}

const assignLoadingState = (prevLoading, currentLoading) => {
  const state = {};
  if (prevLoading && currentLoading) {
    _.assign(state, {loading: false});
  }
  return state;
}

const assignLoadingRecommendationState = (prevLoadingRecommendation, currentLoadingRecommendation) => {
  const state = {};
  if (prevLoadingRecommendation && currentLoadingRecommendation) {
    _.assign(state, {loadingRecommendations: false});
  }
  return state;
}

const assignSavedNewClassifierState = (prevSavedNewClassifier, savedNewClassifier) => {
  const state = {};

  if ((!!savedNewClassifier && !_.isEqual(prevSavedNewClassifier, savedNewClassifier))) {
    _.assign(state, {
      pageNotification: !_.has(savedNewClassifier, 'hasError')
        ? getPageNotificationObject('newClassifier', 'The Label was saved successfully', 'success')
        : getPageNotificationObject('newClassifier', 'The Label name already exists', 'error')
    });
  }
  return state;
}

const assignEmptyPageNotificationState = (prevPageNotification, pageNotification) => {
  const state = {};
  if (prevPageNotification.show && pageNotification.show) {
    _.assign(state, {pageNotification: {show: false, msg: '', type: '', target: ''}});
  }
  return state;
}

const getComponentState = (prevProps, prevState, state, props) => {
  const newState = {};
  const { loading, loadingRecommendations, pageNotification } = state;

  _.assign(newState, assignLoadingState(prevState.loading, loading));
  _.assign(newState, assignLoadingRecommendationState(prevState.loadingRecommendations, loadingRecommendations));
  _.assign(newState, assignSavedNewClassifierState(prevProps.savedNewClassifier, props.savedNewClassifier));
  _.assign(newState, assignEmptyPageNotificationState(prevState.pageNotification, pageNotification));

  return newState;
}

module.exports = {
  getNewStateObject,
  getComponentState
}



// WEBPACK FOOTER //
// ./src/components/entityRecommender/entityRecommender.state.jsx